import React from 'react'
import Box from '@material-ui/core/Box'
import InsertChartOutlinedIcon from '@material-ui/icons/InsertChartOutlined'
import NavigateNextOutlinedIcon from '@material-ui/icons/NavigateNextOutlined'
import Typography from '@material-ui/core/Typography'
import ActionButtons from './action-buttons'
import EventDetails from './index'
import PeopleAltOutlinedIcon from '@material-ui/icons/PeopleAltOutlined'
import { useStyles } from './styles'
import pluralize from 'lib/pluralize'

const CoachEventDetails = ({ event, setIsOpen }) => {
  const classes = useStyles()
  return (
    <EventDetails
      event={event}
      setIsOpen={setIsOpen}
      actionButtons={() => (
        <ActionButtons
          setIsOpen={setIsOpen}
          event={event}
          canEdit={!event.isCanceled && !event.isPast()}
        />
      )}
      participants={
        <Box
          className={classes.clickableRow}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          onClick={() => setIsOpen('participants')}
        >
          <Box display="flex" alignItems="center" className={classes.eventRow}>
            <PeopleAltOutlinedIcon className={classes.eventRowIcon} />
            <Box display="flex" flexDirection="column">
              <Typography variant="body1">
                {event.totalEnrolled}{' '}
                {pluralize(event.totalEnrolled, 'Participant')}
              </Typography>
              {event.maxAttendance ? (
                <Typography variant="body2" className={classes.bodyFontCaption}>
                  {`Max attendance: ${event.maxAttendance} participants • ${
                    event.totalEnrolled > 0
                      ? Math.ceil(
                        (event.totalEnrolled / event.maxAttendance) * 100,
                      )
                      : 0
                  }% full`}
                </Typography>
              ) : null}
            </Box>
          </Box>
          <NavigateNextOutlinedIcon />
        </Box>
      }
      stats={
        <Box
          className={classes.clickableRow}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          onClick={() => setIsOpen('stats')}
        >
          <Box display="flex" alignItems="center" className={classes.eventRow}>
            <InsertChartOutlinedIcon className={classes.eventRowIcon} />
            <Typography variant="body1">Stats</Typography>
          </Box>
          <NavigateNextOutlinedIcon />
        </Box>
      }
    />
  )
}

export default CoachEventDetails
